/** Game names by id (`gameOptions`), for the games of a cabinet. */
export type GameNames = {
  byId: ReadonlyMap<string, string>
  isLoading: boolean
  isError: boolean
}

/**
 * The names of a cabinet's games, sorted: `—` for none or when the names
 * failed to load (never a wrong or missing-looking name), `…` while they
 * load. Ids without a name (a game added since the names loaded) are left out.
 */
export function gameNamesText(
  gameIds: readonly string[],
  { byId, isLoading, isError }: GameNames,
) {
  if (gameIds.length === 0 || isError) {
    return '—'
  }
  if (isLoading) {
    return '…'
  }
  const names = gameIds
    .flatMap((id) => {
      const name = byId.get(id)
      return name === undefined ? [] : [name]
    })
    .toSorted((left, right) => left.localeCompare(right))
  return names.length === 0 ? '—' : names.join(', ')
}
